import { FIELD_TYPES } from './constants';

export const ALL_BRANCHES = 'ALL_BRANCHES';
export const CONDITION_RENDER_IF_NON_GDPR = 'render if (("state.no_klondike_gdpr_setting" EQ "never")) OR (("state.no_klondike_gdpr_setting" EQ "geo") AND (("state.no_klondike_carmen_sandiego_region" NE "eu")))';
export const CONDITION_RENDER_IF_GDPR = 'render if ((state.no_klondike_gdpr_setting EQ always) OR ((state.no_klondike_gdpr_setting EQ geo) AND (state.no_klondike_carmen_sandiego_region EQ eu)))';
export const CONDITION_OPTIONAL_IF_GDPR = 'optional if state.no_klondike_carmen_sandiego_region EQ eu';

export const BRANCHING_FIELD_TYPES = [FIELD_TYPES.DROPDOWN, FIELD_TYPES.RADIO_BUTTON];
export const THANK_YOU_ROUTING_FIELD_TYPES = [FIELD_TYPES.DROPDOWN];
